import React from "react";
import styled from "styled-components";
import { tokens } from "../../public/tokens";
import { MOBILE_BREAKPOINT } from "./breakpoints";
import CheckboxCard from "./CheckboxCard";

const { colors, typography, globals } = tokens;

const StyledFieldset = styled.fieldset({
    margin: 0,
    padding: 0,
    border: 0,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: globals["spacing-1-5"],
});

const StyledTitle = styled.legend({
    margin: 0,
    padding: 0,
    fontFamily: typography.fontFamilies["albert-sans"],
    fontWeight: typography.fontWeights.regular,
    fontSize: typography.fontSize["lg-14px"],
    lineHeight: globals["spacing-5"],
    color: colors.text.primary,
});

const StyledGrid = styled.div(({ $columns }) => ({
    display: "grid",
    gridTemplateColumns: `repeat(${$columns}, minmax(0, 1fr))`,
    gap: globals["spacing-2-5"],

    [`@media (max-width: ${MOBILE_BREAKPOINT})`]: {
        gridTemplateColumns: "minmax(0, 1fr)",
    },
}));

/**
 * Titled grid of CheckboxCards for picking any number of options.
 * @param {{ value: string, label: string, icon?: string, disabled?: boolean }[]} props.options Cards to show.
 * @param {string[]} props.value Values of the checked cards.
 * @param {(nextValue: string[]) => void} props.onChange Receives the new checked values.
 * Also: title, name, columns (desktop columns, default 4; always 1 on mobile).
 */
function CheckboxCardGroup({ title, name, options, value, onChange, columns = 4 }) {
    function handleToggle(optionValue) {
        const nextValue = value.includes(optionValue)
            ? value.filter((selected) => selected !== optionValue)
            : [...value, optionValue];

        onChange(nextValue);
    }

    return (
        <StyledFieldset>
            {title && <StyledTitle>{title}</StyledTitle>}
            <StyledGrid $columns={columns}>
                {options.map((option) => (
                    <CheckboxCard
                        key={option.value}
                        name={name}
                        value={option.value}
                        icon={option.icon}
                        label={option.label}
                        disabled={option.disabled}
                        checked={value.includes(option.value)}
                        onChange={() => handleToggle(option.value)}
                    />
                ))}
            </StyledGrid>
        </StyledFieldset>
    );
}

export default CheckboxCardGroup;
 